import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';

// Error handling configuration
const errorConfig: RequestConfig = {
  errorConfig: {
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      
      const { response } = error;
      
      if (response && response.status) {
        const { status, statusText, url } = response;
        const errorText = response.data?.message || statusText;
        
        notification.error({
          message: `Request Error ${status}: ${url}`,
          description: errorText,
        });
        
        // Redirect to login on 401
        if (status === 401) {
          const { history } = require('@umijs/max');
          history.push('/user/login');
        }
      } else if (!response) {
        notification.error({
          description: 'Network error. Please check your connection.',
          message: 'Network Error',
        });
      }
      
      throw error;
    },
  },
  
  requestInterceptors: [],
  responseInterceptors: [],
};

export { errorConfig };

